import RoleLogic from './logic.js'
const moduleHandler = (LocalStorage, roles) => {
  const role = RoleLogic(LocalStorage)
  return roles[role]
}

export default moduleHandler
